import React, { forwardRef } from 'react';
import { BrandShelfProductName } from './brandshelf-product-name';
import {
  brandShelfItemStyle,
  productNameTextInWidget,
  productInfoWrapper,
  productNameWithoutReviews,
} from './styles';
import { cn } from 'utils/classnames';
import type { ProductCardProps } from 'common/components/product-card/types';
import { BrandShelfProductPriceToDisplay } from './brandshelf-product-price-to-display';
import {
  offerOldPriceWrapper,
  offerWrapper,
  productName,
  productNameText,
} from 'common/components/product-card/styles';
import { useProductCard } from 'common/components/product-card/hooks/use-product-card';
import { ProductImageLink } from 'common/components/product-card/product-image-link';

export const BrandShelfProductCard = forwardRef<HTMLDivElement, ProductCardProps>(
  (
    { className, product, type, label, onClick, onCartAdd, onCartRemove, ratings, onQtyUpdate, inWidget },
    ref,
  ) => {
    const { hasOldPrice, link, loyaltyRewardLabel } = useProductCard({
      product,
      onCartAdd,
      onCartRemove,
      onQtyUpdate,
    });
    const isAnyReviews = Boolean(ratings?.reviewNumber);
    return (
      <div className={cn(brandShelfItemStyle, type, className)} data-qa-product="" ref={ref}>
        <ProductImageLink
          link={link}
          product={product}
          onClick={onClick}
          type={type}
          label={label}
          inWidget={inWidget}
          loyaltyRewardLabel={loyaltyRewardLabel}
        />
        <div className={productInfoWrapper}>
          <div className={cn(type)}>
            <BrandShelfProductName
              data-qa="product-name"
              href={link}
              onClick={() => onClick('productNameLink')}
              className={productName}
              textClassName={cn(
                inWidget ? productNameTextInWidget : productNameText,
                !isAnyReviews && productNameWithoutReviews,
              )}
            >
              {product.displayedName}
            </BrandShelfProductName>
          </div>
          <div className={cn(offerWrapper, type, hasOldPrice ? offerOldPriceWrapper : '')}>
            <BrandShelfProductPriceToDisplay
              hasOldPrice={hasOldPrice}
              price={product.price}
              productPriceCategory={label}
            />
          </div>
        </div>
      </div>
    );
  },
);
